import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0810d90a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../assets/logo.png"
}, null, -1))
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main_field unselectable" }, "Подписанты доверенности", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "unselectable" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main_field unselectable" }, " Добавьте подписантов или выберите из списка ", -1))
const _hoisted_6 = {
  class: "hint_left unselectable",
  style: {"margin-left":"0px","margin-top":"9px"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scroll_body" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hint_left unselectable",
  style: {"margin-bottom":"9px"}
}, " Выбрать подписанта ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hint_left unselectable" }, " Нажмите для добавления нового подписанта ", -1))
const _hoisted_16 = { style: {"position":"absolute","top":"60px","left":"590px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main_field unselectable" }, " 3.1.6 Выбрать главного подписанта для доверенности ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_proxy_list = _resolveComponent("v-menu-proxy-list")!
  const _component_v_select_open = _resolveComponent("v-select-open")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_proxy_list),
    _createElementVNode("div", {
      class: "wrapper",
      style: _normalizeStyle({ display: _ctx.storeDM.dragScroll ? 'block' : 'none' })
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", {
        class: "signatory_list_block",
        onWheel: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.signatory_scroll && _ctx.signatory_scroll(...args)))
      }, [
        _createElementVNode("div", {
          class: "signatory_content_block",
          style: _normalizeStyle({ marginTop: _ctx.signatory_y_pos.val + 'px' })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeDM.signatory_list, (input, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "signatory_block",
              key: index
            }, [
              _createElementVNode("div", _hoisted_6, " Подписант номер " + _toDisplayString(index + 1), 1),
              (_openBlock(), _createElementBlock("div", {
                class: "signatory_input unselectable",
                key: index
              }, _toDisplayString(input.name), 1)),
              _createElementVNode("button", {
                type: "button",
                class: "blue_small_btn",
                onClick: ($event: any) => (_ctx.signatory_delete(index))
              }, _hoisted_9, 8, _hoisted_7)
            ]))
          }), 128))
        ], 4),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "scroll unselectable",
          style: _normalizeStyle({ top: 132 + _ctx.signatory_y_pos.val1 + 'px' }),
          onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signatory_drag && _ctx.signatory_drag(...args))),
          onMousemove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.signatory_drag && _ctx.signatory_drag(...args)))
        }, _hoisted_11, 36)), [
          [_directive_touch, _ctx.signatory_drag, "drag"],
          [_directive_touch, _ctx.signatory_drag, "press"],
          [_directive_touch, _ctx.signatory_drag, "release"]
        ])
      ], 32),
      _hoisted_12,
      _createVNode(_component_v_select_open, {
        options: _ctx.storeDM.save_obj.signatory_options,
        title_select: _ctx.signatory_title,
        onChangeSelect: _ctx.signatory_select,
        z_index: 1,
        margin_top: '-9px'
      }, null, 8, ["options", "title_select", "onChangeSelect"]),
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _createElementVNode("button", {
        type: "button",
        class: "blue_btn",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signatory_add())),
        style: {"float":"left","margin-left":"10px"}
      }, " Добавить подписанта "),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _hoisted_18,
        (_openBlock(), _createBlock(_component_v_select_open, {
          options: _ctx.storeDM.signatory_list,
          title_select: _ctx.signatory_main_title,
          onChangeSelect: _ctx.signatory_main_select,
          default_select: _ctx.storeDM.save_obj.signatory_main,
          key: _ctx.storeDM.save_obj.signatory_main,
          z_index: 1,
          margin_top: '-9px'
        }, null, 8, ["options", "title_select", "onChangeSelect", "default_select"]))
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      disabled: !_ctx.step_next,
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 10, _hoisted_19)
  ], 64))
}